export const statuses = {
    ACCEPTED: "accepted",
    COMPLETED: "completed",
    SUBMITTED: "submitted",
    CANCELED: "canceled",
    RELEASED: "released",
};

export const commentsTags = {
    values: {
        system: "request_portal",
        page: "bulk_upload_request",
    },
};

export const fileTypes = {
    SANITIZED: "sanitized",
    REPORT: "report",
    DRAFT: "draft",
};
